export const notificationType = (notificationType, friendName, reasonDenyType = null) => {
	switch (notificationType) {
	case 2: {
		return friendName + 'さんがオンラインになりました'
	}
	case 3: {
		return 'ログインボーナスを獲得しました'
	}
	case 4: {
		return friendName + 'さんがタイムラインを投稿しました'
	}
	case 5: {
		return 'タイムラインが承認されました'
	}
	case 6: {
		return 'タイムラインが否認されました'
	}
	case 7: {
		return 'タイムラインコメントが承認されました'
	}
	case 8: {
		return 'タイムラインコメントが否認されました'
	}
	case 9: {
		return 'コメント返信が承認されました'
	}
	case 10: {
		return 'コメント返信が否認されました'
	}
	case 11: {
		return 'プロフィール情報が更新されました'
	}
	case 12: {
		return 'プロフィール情報が一部更新されました'
	}
	case 13: {
		return 'プロフィール情報の更新が否認されました'
	}
	case 14: {
		return friendName + 'さんからチャット相談の依頼がありました'
	}
	case 15: {
		return friendName + 'さんから電話相談の依頼がありました'
	}
	case 17: {
		return friendName + 'さんからタイムラインにコメントがありました'
	}
	case 18: {
		return friendName + 'さんからコメントに返信がありました'
	}
	case 19: {
		return friendName + 'さんからいいねがつきました'
	}
	case 21: {
		return friendName + 'さんからお気に入り登録されました。無料メッセージでアピールしましょう！'
	}
	case 23: {
		return 'プロフィール画像の加工が完了しました。'
	}
	case 24: {
		return 'プロフィール画像は承認されました。'
	}
	case 25: {
		return 'プロフィール画像は否認されました。'
	}
	case 27: {
		return 'チャットリクエストがキャンセルされました。'
	}
	case 28: {
		return '通話リクエストがキャンセルされました。'
	}
	case 29: {
		return 'ログインボーナスを獲得しました'
	}
	case 30: {
		return 'ミッションをクリアしました'
	}
	case 35: {
		return '教えて先生の回答が承認されました。'
	}
	case 36: {
		return '教えて先生の回答が否認されました。'
	}
	case 37: {
		return 'あなたの回答がベストアンサーに選ばれました！'
	}
	case 38: {
		return friendName + 'さんからチャット相談リクエストがありました'
	}
	case 39: {
		return friendName + 'さんから電話相談リクエストがありました'
	}
	case 42: {
		return 'あなたの回答にGoodがつきました！'
	}
	case 41: {
		return 'ステラ運営事務局からメールが届いています。'
	}
	case 49: {
		return '紹介した占い師が紹介ボーナスをゲットしました。'
	}
	case 51: {
		return 'あなたの一言コメントは承認されました。'
	}
	case 52: {
		return 'あなたの一言コメントは否認されました。'
	}
	case 55: {
		return '年齢認証が承認されました。'
	}
	case 56: {
		return '年齢認証が否認されました。'
	}
	case 64: {
		return '紹介したお客様が登録を完了しました。紹介ボーナスが受け取れます！'
	}
	case 71: {
		return 'ランキングイベントのボーナスを加算しました！'
	}
	case 73: {
		return 'プレミアムメニューは承認されました。'
	}
	case 74: {
		return 'プレミアムメニューは否認されました。[身体に影響を与えるメニューのため（例：体調が良くなる、身体が軽くなる）]'
	}
	case 75: {
		return 'プレミアムメニューは否認されました。[モノに対するメニューのため（例：家の環境を整える）]'
	}
	case 76: {
		return 'プレミアムメニューは否認されました。[他人に害を与えるメニューのため（例：呪い）]'
	}
	case 77: {
		return 'プレミアムメニューは否認されました。[占いとは無関係、あるいは占い師としての技術を伝えるメニューのため（例：◯◯についての鑑定方法を教える）]'
	}
	case 78: {
		return 'プレミアムメニューは否認されました。[グッズの販売や発送を伴うメニュー（例：念を込めたパワーストーンを送る）]'
	}
	case 79: {
		return 'プレミアムメニューは否認されました。[ユーザー様とコミュニケーションを取らないメニューのため]'
	}
	case 80: {
		return 'プレミアムメニューは否認されました。[販売方法が適切でないため（併せ販売や継続購入など、注意事項をお読みください）]'
	}
	case 81: {
		return 'プレミアムメニューは否認されました。[高額すぎるため]'
	}
	case 82: {
		return 'プレミアムメニューは否認されました。[問題のあるメニューのため（詳細はお問い合わせください）]'
	}
	case 84: {
		return 'プレミアムメニューは否認されました。[非承認のメニュー：趣旨と異なる、鑑定で行うべき内容のため]'
	}
	case 85: {
		return 'プレミアムメニューは否認されました。[説明に不明点・不足がある。あるいはプレミアムメニュー欄で説明が完結されていないため]'
	}
	case 86: {
		return 'プレミアムメニューは否認されました。[誇大表現・断定表現が含まれているため]'
	}
	case 83: {
		return friendName + ' プレミアムメニューは承認されました。'
	}
	case 88: {
		return 'クイック精算の申請が行われました。事務局の処理をお待ちください（翌営業日の予定）'
	}
	case 89: {
		return '定期精算の申請（自動）が行われました。10日までに振込が実施される予定です。'
	}
	case 90: {
		return '今月の定期精算は実施されませんでした。詳しくは「定期精算について」をご覧ください。'
	}
	case 91: {
		return '精算申請が処理されました。翌営業日に振込が行われる予定です。'
	}
	case 92: {
		return '精算処理が行われませんでした。条件や口座設定を見直していただき、不明点があればお問い合わせください。'
	}
	case 93: {
		return '精算処理が組み戻しになりました。手数料の880ptsを減算した上でポイントをお戻ししています。ご登録の銀行口座情報を確認いただき、不明点があればお問い合わせください。'
	}
	default: {
		return notificationType + friendName
	}
	}
}

export const notificationTypeLink = (notification) => {
	const notificationType = notification.notificationType
	switch (notificationType) {
	case 5:
	case 6:
	case 7:
	case 8:
	case 9:
	case 10:
	case 17:
	case 18:
	case 19: {
		return '/home/timeline'
	}
	case 11:
	case 12:
	case 13:
	case 23:
	case 24:
	case 25: {
		return '/home/setting'
	}
	case 14:
	case 15:
	case 21:
	case 27:
	case 28:
	case 38:
	case 39: {
		return `/home/chat/${notification.friendId}`
	}
	case 29:
	case 30:
	case 49:
	case 51:
	case 52: {
		return '/home'
	}
	case 35:
	case 36: {
		return '/home/answer/answer-log'
	}
	case 37: {
		return '/home/answer'
	}
	case 41: {
		return `/home/contact/detail/${notification.threadId}`
	}
	case 42: {
		return `/home/answer/detail/${notification.questionId}`
	}
	case 55: {
		return '/home/setting/account'
	}
	case 56: {
		return '/home/setting/account'
	}
	case 71: {
		return {
			pathname: '/home/event',
			params: {
				index: 1
			}
		}
	}
	case 73: {
		return '/home/setting/menu-premium'
	}
	case 74:
	case 75:
	case 76:
	case 77:
	case 78:
	case 79:
	case 80:
	case 81:
	case 82:
	case 84:
	case 85:
	case 86:
	{
		return '/home/setting/menu-premium'
	}
	case 83: {
		return `/home/chat/${notification.friendId}`
	}
	case 88:
	case 89:
	case 90:
	case 91:
	case 92:
	case 93: {
		return '/home/reward'
	}

	default: {
		return '#'
	}
	}
}
